export { default as InvestorConditionsTable } from './InvestorConditionsTable';
